/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ERPNetvisorIntegrationSettings'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ERPNetvisorIntegrationSettings'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ERPNetvisorIntegrationSettingsApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.ERPNetvisorIntegrationSettings);
  }
}(this, function(ApiClient, ERPNetvisorIntegrationSettings) {
  'use strict';

  /**
   * ERPNetvisorIntegrationSettings service.
   * @module api/ERPNetvisorIntegrationSettingsApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new ERPNetvisorIntegrationSettingsApi. 
   * @alias module:api/ERPNetvisorIntegrationSettingsApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the eRPNetvisorIntegrationSettingsAddPut operation.
     * @callback module:api/ERPNetvisorIntegrationSettingsApi~eRPNetvisorIntegrationSettingsAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/ERPNetvisorIntegrationSettings} body 
     * @param {module:api/ERPNetvisorIntegrationSettingsApi~eRPNetvisorIntegrationSettingsAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.eRPNetvisorIntegrationSettingsAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPNetvisorIntegrationSettingsAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling eRPNetvisorIntegrationSettingsAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/ERPNetvisorIntegrationSettings/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the eRPNetvisorIntegrationSettingsDeleteGet operation.
     * @callback module:api/ERPNetvisorIntegrationSettingsApi~eRPNetvisorIntegrationSettingsDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} primaryKey 
     * @param {module:api/ERPNetvisorIntegrationSettingsApi~eRPNetvisorIntegrationSettingsDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.eRPNetvisorIntegrationSettingsDeleteGet = function(_4SAPIAppID, primaryKey, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPNetvisorIntegrationSettingsDeleteGet";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling eRPNetvisorIntegrationSettingsDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ERPNetvisorIntegrationSettings/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the eRPNetvisorIntegrationSettingsEditPut operation.
     * @callback module:api/ERPNetvisorIntegrationSettingsApi~eRPNetvisorIntegrationSettingsEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/ERPNetvisorIntegrationSettings} body 
     * @param {Integer} primaryKey 
     * @param {module:api/ERPNetvisorIntegrationSettingsApi~eRPNetvisorIntegrationSettingsEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.eRPNetvisorIntegrationSettingsEditPut = function(_4SAPIAppID, body, primaryKey, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPNetvisorIntegrationSettingsEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling eRPNetvisorIntegrationSettingsEditPut";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling eRPNetvisorIntegrationSettingsEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ERPNetvisorIntegrationSettings/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the eRPNetvisorIntegrationSettingsImportBudgetGet operation.
     * @callback module:api/ERPNetvisorIntegrationSettingsApi~eRPNetvisorIntegrationSettingsImportBudgetGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * importBudget
     * @param {String} _4SAPIAppID 
     * @param {Integer} legalEntityID 
     * @param {Integer} year 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.trackingLevelID 
     * @param {module:api/ERPNetvisorIntegrationSettingsApi~eRPNetvisorIntegrationSettingsImportBudgetGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.eRPNetvisorIntegrationSettingsImportBudgetGet = function(_4SAPIAppID, legalEntityID, year, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPNetvisorIntegrationSettingsImportBudgetGet";
      }

      // verify the required parameter 'legalEntityID' is set
      if (legalEntityID == undefined || legalEntityID == null) {
        throw "Missing the required parameter 'legalEntityID' when calling eRPNetvisorIntegrationSettingsImportBudgetGet";
      }

      // verify the required parameter 'year' is set
      if (year == undefined || year == null) {
        throw "Missing the required parameter 'year' when calling eRPNetvisorIntegrationSettingsImportBudgetGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'legalEntityID': legalEntityID,
        'year': year,
        'trackingLevelID': opts['trackingLevelID']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ERPNetvisorIntegrationSettings/importBudget', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the eRPNetvisorIntegrationSettingsLoadAllGet operation.
     * @callback module:api/ERPNetvisorIntegrationSettingsApi~eRPNetvisorIntegrationSettingsLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ERPNetvisorIntegrationSettings>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/ERPNetvisorIntegrationSettingsApi~eRPNetvisorIntegrationSettingsLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/ERPNetvisorIntegrationSettings>}
     */
    this.eRPNetvisorIntegrationSettingsLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPNetvisorIntegrationSettingsLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [ERPNetvisorIntegrationSettings];

      return this.apiClient.callApi(
        '/ERPNetvisorIntegrationSettings/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the eRPNetvisorIntegrationSettingsTestNetvisorIntegrationSettingsGet operation.
     * @callback module:api/ERPNetvisorIntegrationSettingsApi~eRPNetvisorIntegrationSettingsTestNetvisorIntegrationSettingsGetCallback
     * @param {String} error Error message, if any.
     * @param {'Boolean'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * testNetvisorIntegrationSettings
     * @param {String} _4SAPIAppID 
     * @param {String} integrationKey 
     * @param {String} integrationHash 
     * @param {String} organizationIdentifier 
     * @param {module:api/ERPNetvisorIntegrationSettingsApi~eRPNetvisorIntegrationSettingsTestNetvisorIntegrationSettingsGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Boolean'}
     */
    this.eRPNetvisorIntegrationSettingsTestNetvisorIntegrationSettingsGet = function(_4SAPIAppID, integrationKey, integrationHash, organizationIdentifier, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPNetvisorIntegrationSettingsTestNetvisorIntegrationSettingsGet";
      }

      // verify the required parameter 'integrationKey' is set
      if (integrationKey == undefined || integrationKey == null) {
        throw "Missing the required parameter 'integrationKey' when calling eRPNetvisorIntegrationSettingsTestNetvisorIntegrationSettingsGet";
      }

      // verify the required parameter 'integrationHash' is set
      if (integrationHash == undefined || integrationHash == null) {
        throw "Missing the required parameter 'integrationHash' when calling eRPNetvisorIntegrationSettingsTestNetvisorIntegrationSettingsGet";
      }

      // verify the required parameter 'organizationIdentifier' is set
      if (organizationIdentifier == undefined || organizationIdentifier == null) {
        throw "Missing the required parameter 'organizationIdentifier' when calling eRPNetvisorIntegrationSettingsTestNetvisorIntegrationSettingsGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'integrationKey': integrationKey,
        'integrationHash': integrationHash,
        'organizationIdentifier': organizationIdentifier
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Boolean';

      return this.apiClient.callApi(
        '/ERPNetvisorIntegrationSettings/testNetvisorIntegrationSettings', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the eRPNetvisorIntegrationSettingsUpdateNetvisorDataGet operation.
     * @callback module:api/ERPNetvisorIntegrationSettingsApi~eRPNetvisorIntegrationSettingsUpdateNetvisorDataGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * updateNetvisorData
     * @param {String} _4SAPIAppID 
     * @param {module:api/ERPNetvisorIntegrationSettingsApi~eRPNetvisorIntegrationSettingsUpdateNetvisorDataGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.eRPNetvisorIntegrationSettingsUpdateNetvisorDataGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPNetvisorIntegrationSettingsUpdateNetvisorDataGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ERPNetvisorIntegrationSettings/updateNetvisorData', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
